/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObject from './MoserObject';
import InstanceType from './InstanceType';
import JoinFilterType from './JoinFilterType';
import ComparisonOperatorType from './ComparisonOperatorType';
import ReferenceResolver from './ReferenceResolver';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/JoinFilterType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ComparisonOperatorType (runtime) // new
//@import com/ibm/bi/platform/moser/common/utils/ReferenceResolver (runtime) // resolveRelationshipLink

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="instanceType" type="{}instanceType" minOccurs="0"/&gt; &lt;element name="left" type="{}cardinalityType"/&gt; &lt;element name="right" type="{}cardinalityType"/&gt; &lt;choice&gt; &lt;element name="expression" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="link" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="leftRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="rightRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="comparisonOperator" type="{}comparisonOperatorType" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/choice&gt; &lt;element name="joinFilterType" type="{}joinFilterType" minOccurs="0"/&gt; &lt;element name="shortcutTargetRelationshipRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class Relationship extends ObjectType{

	ref = null;

	instanceType = null;

	left = null;

	right = null;

	expression = null;

	link = null;

	joinFilterType = null;

	shortcutTargetRelationshipRef = null;

	_referencedObject = null;



	/**
	 * Gets the value of the ref property.
	 * @return {String} possible object is {@link String}
	 */
	getRef() {
		return this.ref;
	}

	/**
	 * Sets the value of the ref property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRef(value) {
		var oldValue = this.ref;
		this.ref = value;
		this._setAndNotify(36, oldValue, value, false, true);
		this._referencedObject = null;
	}

	/**
	 * Gets the value of the instanceType property.
	 * @return {InstanceType} possible object is {@link InstanceType}
	 */
	getInstanceType() {
		return this.instanceType;
	}

	/**
	 * Sets the value of the instanceType property.
	 * @param {InstanceType} value allowed object is {@link InstanceType}
	 */
	setInstanceType(value) {
		var oldValue = this.instanceType;
		this.instanceType = value;
		this._setAndNotify(58, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the left property.
	 * @return {CardinalityType} possible object is {@link CardinalityType}
	 */
	getLeft() {
		return this.left;
	}

	/**
	 * Sets the value of the left property.
	 * @param {CardinalityType} value allowed object is {@link CardinalityType}
	 */
	setLeft(value) {
		var oldValue = this.left;
		this.left = value;
		this._setAndNotify(232, oldValue, value, true, true);
	}

	/**
	 * Gets the value of the right property.
	 * @return {CardinalityType} possible object is {@link CardinalityType}
	 */
	getRight() {
		return this.right;
	}

	/**
	 * Sets the value of the right property.
	 * @param {CardinalityType} value allowed object is {@link CardinalityType}
	 */
	setRight(value) {
		var oldValue = this.right;
		this.right = value;
		this._setAndNotify(234, oldValue, value, true, true);
	}

	/**
	 * Gets the value of the expression property.
	 * @return {String} possible object is {@link String}
	 */
	getExpression() {
		return this.expression;
	}

	/**
	 * Sets the value of the expression property.
	 * @param {String} value allowed object is {@link String}
	 */
	setExpression(value) {
		var oldValue = this.expression;
		this.expression = value;
		this._setAndNotify(43, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the link property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the link property. <p> For example, to add a new item, do as follows: <pre> getLink().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Relationship.Link}
	 */
	getLink() {
		if (!this.link) {
			this.link = [];
		}
		return this.link;
	}

	/**
	 * Gets the value of the joinFilterType property.
	 * @return {JoinFilterType} possible object is {@link JoinFilterType}
	 */
	getJoinFilterType() {
		return this.joinFilterType;
	}

	/**
	 * Sets the value of the joinFilterType property.
	 * @param {JoinFilterType} value allowed object is {@link JoinFilterType}
	 */
	setJoinFilterType(value) {
		var oldValue = this.joinFilterType;
		this.joinFilterType = value;
		this._setAndNotify(235, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the shortcutTargetRelationshipRef property.
	 * @return {String} possible object is {@link String}
	 */
	getShortcutTargetRelationshipRef() {
		return this.shortcutTargetRelationshipRef;
	}

	/**
	 * Sets the value of the shortcutTargetRelationshipRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setShortcutTargetRelationshipRef(value) {
		var oldValue = this.shortcutTargetRelationshipRef;
		this.shortcutTargetRelationshipRef = value;
		this._setAndNotify(236, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the <code>link</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Link</code> elements, or <code>null</code> if not set
	 */
	basicGetLink() {
		return this.link;
	}

	/**
	 * Creates a new instance of <code>Relationship</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Relationship</code> object from.
	 * @return {Relationship} an object of type <code>Relationship</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createRelationship();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addLinkAt(position, item) {
		this._addAtAndNotify(this.getLink(), position, item, 233, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addLink(item) {
		this.addLinkAt(this.getLink().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeLinkAt(position) {
		this._removeAtAndNotify(this.getLink(), position, 233, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeLink(item) {
		var i = this.getLink().indexOf(item);
		if (i >= 0) {
			this.removeLinkAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Relationship";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 36, "ref", null));
		featureList.push(this.createFeature(false, true, false, 58, "instanceType", InstanceType));
		var clazz;
		if (factory) {
			clazz = factory.createCardinalityType().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 232, "left", clazz));
		if (factory) {
			clazz = factory.createCardinalityType().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 234, "right", clazz));
		featureList.push(this.createFeature(false, false, false, 43, "expression", null));
		if (factory) {
			clazz = factory.createRelationshipLink().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 233, "link", clazz));
		featureList.push(this.createFeature(false, true, false, 235, "joinFilterType", JoinFilterType));
		featureList.push(this.createFeature(false, false, false, 236, "shortcutTargetRelationshipRef", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 36:
			this.setRef((value));
			break;
		case 43:
			this.setExpression((value));
			break;
		case 232:
			this.setLeft((value));
			break;
		case 58:
			this.setInstanceType((value));
			break;
		case 234:
			this.setRight((value));
			break;
		case 235:
			this.setJoinFilterType((value));
			break;
		case 236:
			this.setShortcutTargetRelationshipRef((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 233:
			this.link = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 36:
			return this.getRef();
		case 43:
			return this.getExpression();
		case 232:
			return this.getLeft();
		case 58:
			return this.getInstanceType();
		case 233:
			return this.getLink();
		case 234:
			return this.getRight();
		case 235:
			return this.getJoinFilterType();
		case 236:
			return this.getShortcutTargetRelationshipRef();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 36:
			return this.getRef();
		case 43:
			return this.getExpression();
		case 232:
			return this.getLeft();
		case 58:
			return this.getInstanceType();
		case 233:
			return this.basicGetLink();
		case 234:
			return this.getRight();
		case 235:
			return this.getJoinFilterType();
		case 236:
			return this.getShortcutTargetRelationshipRef();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 233:
			this.addLinkAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 233:
			this.addLink((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 233:
			this.removeLinkAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 233:
			this.removeLink((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}

	/**
	 * Set the resolved object based on reference.
	 * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	 */
	setReferencedObject(referencedObject) {
		this._referencedObject = referencedObject;
	}

	/**
	 * Get the resolved object based on reference.
	 * @return {MoserObject} the referenced <code>MoserObject</code>
	 */
	getReferencedObject() {
		return this._referencedObject;
	}

	clone() {
		var cloned = (super.clone());
		cloned.setReferencedObject(this._referencedObject);
		return cloned;
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="leftRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="rightRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="comparisonOperator" type="{}comparisonOperatorType" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
Relationship.Link = class extends MoserObject{

	leftRef = null;

	rightRef = null;

	comparisonOperator = null;

	_referencedObjectLeft = null;

	_referencedObjectRight = null;



	/**
	 * Gets the value of the leftRef property.
	 * @return {String} possible object is {@link String}
	 */
	getLeftRef() {
		return this.leftRef;
	}

	/**
	 * Sets the value of the leftRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setLeftRef(value) {
		var oldValue = this.leftRef;
		this.leftRef = value;
		this._setAndNotify(150, oldValue, value, false, false);
		this._referencedObjectLeft = null;
	}

	/**
	 * Gets the value of the rightRef property.
	 * @return {String} possible object is {@link String}
	 */
	getRightRef() {
		return this.rightRef;
	}

	/**
	 * Sets the value of the rightRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRightRef(value) {
		var oldValue = this.rightRef;
		this.rightRef = value;
		this._setAndNotify(151, oldValue, value, false, false);
		this._referencedObjectRight = null;
	}

	/**
	 * Gets the value of the comparisonOperator property.
	 * @return {ComparisonOperatorType} possible object is {@link ComparisonOperatorType}
	 */
	getComparisonOperator() {
		return this.comparisonOperator;
	}

	/**
	 * Sets the value of the comparisonOperator property.
	 * @param {ComparisonOperatorType} value allowed object is {@link ComparisonOperatorType}
	 */
	setComparisonOperator(value) {
		var oldValue = this.comparisonOperator;
		this.comparisonOperator = value;
		this._setAndNotify(152, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>Link</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Link</code> object from.
	 * @return {Link} an object of type <code>Link</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createRelationshipLink();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Link";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 150, "leftRef", null));
		featureList.push(this.createFeature(false, false, false, 151, "rightRef", null));
		featureList.push(this.createFeature(false, true, false, 152, "comparisonOperator", ComparisonOperatorType));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 150:
			this.setLeftRef((value));
			break;
		case 151:
			this.setRightRef((value));
			break;
		case 152:
			this.setComparisonOperator((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 150:
			return this.getLeftRef();
		case 151:
			return this.getRightRef();
		case 152:
			return this.getComparisonOperator();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 150:
			return this.getLeftRef();
		case 151:
			return this.getRightRef();
		case 152:
			return this.getComparisonOperator();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the resolved object based on reference.
	 * @param {MoserObject} referencedObjectLeft the referenced <code>MoserObject</code> from 'leftRef
	 */
	setReferencedObjectLeft(referencedObjectLeft) {
		this._referencedObjectLeft = referencedObjectLeft;
	}

	/**
	 * Get the resolved object based on reference.
	 * @return {MoserObject} the referenced <code>MoserObject</code> from 'leftRef
	 */
	getReferencedObjectLeft() {
		if (!this._referencedObjectLeft) {
			ReferenceResolver.resolveRelationshipLink((this.getParent()));
		}
		return this._referencedObjectLeft;
	}

	/**
	 * Set the resolved object based on reference.
	 * @param {MoserObject} referencedObjectRight the referenced <code>MoserObject</code> from 'rightRef
	 */
	setReferencedObjectRight(referencedObjectRight) {
		this._referencedObjectRight = referencedObjectRight;
	}

	/**
	 * Get the resolved object based on reference.
	 * @return {MoserObject} the referenced <code>MoserObject</code> from 'rightRef
	 */
	getReferencedObjectRight() {
		if (!this._referencedObjectRight) {
			ReferenceResolver.resolveRelationshipLink((this.getParent()));
		}
		return this._referencedObjectRight;
	}
}


// WEBPACK FOOTER //
// ./src/generated/Relationship.js